// Environment configuration from .env file
// For Create React App, variables must start with REACT_APP_
const inozENV = process.env.REACT_APP_ENV || "PRODUCTION"

let API_URL = process.env.REACT_APP_API_URL || "https://api.cask.co.nz"
let ANGULAR_URL = process.env.REACT_APP_ANGULAR_URL || "https://app.cask.co.nz/#"
let WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://cask.co.nz"

if (inozENV === "DEVELOPMENT") {
    API_URL = process.env.REACT_APP_API_URL || "https://localhost"
    ANGULAR_URL = process.env.REACT_APP_ANGULAR_URL || "http://localhost:4200"
    WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "http://localhost:3000"
}

export { API_URL, ANGULAR_URL, inozENV, WEBSITE_URL }